import { occFetch, occUrl } from "~/app/api/occ/occFetch";

interface Props {
  email: string;
  firstName: string;
  lastName: string;
  note: string;
  sharedConfigurations: string[];
}

export const sendLinearConfigurationsViaEmail = (data: Props): Promise<{ error?: string }> => {
  return occFetch(occUrl("/sendLinearConfigurationsViaEmail"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json().catch(() => ({}));
    }
  });
};
